export var TwilioCallStatusEnum;
(function (TwilioCallStatusEnum) {
    TwilioCallStatusEnum[TwilioCallStatusEnum["NONE"] = 0] = "NONE";
    TwilioCallStatusEnum[TwilioCallStatusEnum["QUEUED"] = 10] = "QUEUED";
    TwilioCallStatusEnum[TwilioCallStatusEnum["INITIATED"] = 20] = "INITIATED";
    TwilioCallStatusEnum[TwilioCallStatusEnum["RINGING"] = 30] = "RINGING";
    TwilioCallStatusEnum[TwilioCallStatusEnum["IN_PROGRESS"] = 40] = "IN_PROGRESS";
    TwilioCallStatusEnum[TwilioCallStatusEnum["COMPLETED"] = 50] = "COMPLETED";
    TwilioCallStatusEnum[TwilioCallStatusEnum["BUSY"] = 60] = "BUSY";
    TwilioCallStatusEnum[TwilioCallStatusEnum["FAILED"] = 70] = "FAILED";
    TwilioCallStatusEnum[TwilioCallStatusEnum["NO_ANSWER"] = 80] = "NO_ANSWER";
    TwilioCallStatusEnum[TwilioCallStatusEnum["CANCELED"] = 90] = "CANCELED";
})(TwilioCallStatusEnum || (TwilioCallStatusEnum = {}));
export var mapTwilioCallStatusToEnum = function (callStatus) {
    switch (callStatus) {
        case 'none':
            return TwilioCallStatusEnum.NONE;
        case 'queued':
            return TwilioCallStatusEnum.QUEUED;
        case 'initiated':
            return TwilioCallStatusEnum.INITIATED;
        case 'ringing':
            return TwilioCallStatusEnum.RINGING;
        case 'in-progress':
            return TwilioCallStatusEnum.IN_PROGRESS;
        case 'completed':
            return TwilioCallStatusEnum.COMPLETED;
        case 'busy':
            return TwilioCallStatusEnum.BUSY;
        case 'failed':
            return TwilioCallStatusEnum.FAILED;
        case 'no-answer':
            return TwilioCallStatusEnum.NO_ANSWER;
        case 'canceled':
            return TwilioCallStatusEnum.CANCELED;
        default:
            return TwilioCallStatusEnum.NONE;
    }
};
//# sourceMappingURL=twilio-call-status.js.map